export * from './ich-sorter.component';
export * from './ich-sorter.component.module';